var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-simple-table',[_c('tbody',_vm._l((_vm.items),function(item,index){return ((item.val && item.hideEmpty) || !item.hideEmpty)?_c('t-orm-simple-data-item',{key:index,attrs:{"item":item}}):_vm._e()}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }